import React from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import classNames from 'classnames';

// actions
import { goBack, goForward } from 'script-flow';
import { openQuitFlowModal } from 'current/uiwidgets';
import { closeMessage as closeMessageFunc } from 'messages';

// selectors
import {
  canGoBack as canGoBackFunc,
  canGoForward as canGoForwardFunc
} from 'advanced/selectors';
import { getAllMessages } from 'messages/selectors';
import { isAppMode as isAppModeFunc } from 'settings/selectors';
import { getStepNumber, isLastStep as isLastStepFunc } from 'script-flow/selectors';
import { isResourcePending } from 'loading/selectors';

// constants
import { resourceType } from 'constants/loading';

// components
import QuitFlowModalContainer from 'common/modals/QuitFlowModalContainer';
import ScriptFlowHeader from 'common/ScriptFlowHeader';
import ScriptFlowBody from 'common/ScriptFlowBody';
import MessagePanel from 'messages/MessagePanel';
import ReviewHarvestHistoryContainer from 'advanced/review-harvest-history/ReviewHarvestHistoryContainer';
import PlantingPlan from 'advanced/planting-plan/PlantingPlan';
import NotEnoughDataForZonesError from 'common/modals/NotEnoughDataForZonesError';
import AwaitingRequirementsCheck from './review-harvest-history/AwaitingRequirementsCheck';
import ReviewScenariosWithDensityTool from './review-scenarios/ReviewScenariosWithDensityTool';

const steps = { 
  // Step 0 will only show in the case of deep linking before all data has loaded
  0: ReviewHarvestHistoryContainer,
  1: ReviewHarvestHistoryContainer,
  2: PlantingPlan,
  3: ReviewScenariosWithDensityTool
};

let AdvancedScriptContainer = ({
  canGoBack,
  canGoForward,
  closeMessage,
  isAppMode,
  isLastStep,
  isStartZoneGenerationPending,
  messages,
  onClickBack,
  onClickCancel,
  onClickForward,
  stepNumber
}) => {

  const classString = classNames({
    'vra-advanced-script': true,
    'vra-route-container': true,
    'vra-route-container--advanced': true,
    'vra-route-container--app-mode': isAppMode,
    'vra-route-container--script-flow': true
  });

  const Content = isStartZoneGenerationPending ? AwaitingRequirementsCheck : steps[stepNumber];
  return (
    <div className={classString}>
      <MessagePanel
        closeMessage={closeMessage}
        isToolbarShown={false}
        messages={messages}
      />
      <ScriptFlowHeader
        isFinalAdvancedPlanting={isLastStep}
        isVisible={!isAppMode}
        onClickCancel={() => onClickCancel(stepNumber)}
      />
      <ScriptFlowBody
        canGoBack={canGoBack}
        canGoForward={canGoForward}
        isAdvancedScripting={true}
        isAppMode={isAppMode}
        isFinalStep={isLastStep}
        onClickBack={onClickBack}
        onClickForward={onClickForward}>
        <Content />
      </ScriptFlowBody>
      <QuitFlowModalContainer />
      <NotEnoughDataForZonesError />
    </div>
  );
};

AdvancedScriptContainer.propTypes = {
  canGoBack: propTypes.bool.isRequired,
  canGoForward: propTypes.bool.isRequired,
  closeMessage: propTypes.func.isRequired,
  isAppMode: propTypes.bool.isRequired,
  isLastStep: propTypes.bool.isRequired,
  isStartZoneGenerationPending: propTypes.bool.isRequired,
  messages: propTypes.array.isRequired,
  onClickBack: propTypes.func.isRequired,
  onClickCancel: propTypes.func.isRequired,
  onClickForward: propTypes.func.isRequired,
  stepNumber: propTypes.number.isRequired
};

AdvancedScriptContainer = connect(
  (state) => {
    return {
      canGoBack: canGoBackFunc(state),
      canGoForward: canGoForwardFunc(state),
      isAppMode: isAppModeFunc(state),
      isLastStep: isLastStepFunc(state),
      messages: getAllMessages(state),
      stepNumber: getStepNumber(state),
      isStartZoneGenerationPending: isResourcePending({ 
        state,
        type: resourceType.ADVANCED_SCRIPT_AVAILABILITY,
        id: resourceType.ADVANCED_SCRIPT_AVAILABILITY
      }) 
    };
  },
  (dispatch) => {
    return {
      closeMessage: (id) => { dispatch(closeMessageFunc(id)); },

      onClickBack: () => {
        dispatch(goBack());
      },
      onClickForward: () => {
        dispatch(goForward());
      },
      onClickCancel: () => {
        dispatch(openQuitFlowModal());
      }
    };
  }
)(AdvancedScriptContainer);
export default AdvancedScriptContainer;
